module.exports = __webpack_public_path__ + "static/01-74a53793d7568b3257eda764fb4bfa41.jpg";